/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import { useEffect, useState } from "react";

import { useUI } from "state";

import { CameraIcon } from "components/icons";

import Cropper from "./Cropper";
import { Button } from "components/ui/Button";
import Avatar from "components/ui/Avatar";

const ImageCropper = ({
  onUpload,
  folderName = "users",
  providedImage,
  hasBorder = false,
  disabled = false,
  width = null,
  height = null,
}) => {
  const { openNestedModal, closeNestedModal } = useUI();
  const [image, setImage] = useState("");

  const handleUploadImage = (url) => {
    onUpload(url);
    setImage(url);

    closeNestedModal();
  };

  useEffect(() => {
    if (providedImage === image) return;
    setImage(providedImage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [providedImage]);

  return (
    <div test-id="u5VvYRLs">
      <Button
        variant="unstyled"
        disabled={disabled}
        onClick={() => {
          openNestedModal({
            content: (
              <Cropper
                onUpload={handleUploadImage}
                providedImage={image}
                folderName={folderName}
                width={width}
                height={height}
                test-id="RWJE0E7F"
              />
            ),
          });
        }}
        test-id="ttWztf4J"
      >
        <div className="relative" test-id="ESB0g1uD">
          <Avatar
            src={image}
            alt="user-image"
            hasBorder={
              hasBorder || image === null || (image && image.length === 0)
            }
            fit="cover"
            size="xl"
            test-id="gF_9gSuk"
          />

          <div className="absolute right-0 bottom-4" test-id="2ElNCz90">
            <CameraIcon test-id="80UcKySZ" />
          </div>
        </div>
      </Button>
    </div>
  );
};

export default ImageCropper;
